"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.message_processor = void 0;
const ArduinoGlobals_1 = require("../../System/Simulator/ArduinoGlobals");
const search_utils_1 = require("./search_utils");
const sprite_sheet_1 = require("./sprite_sheet");
const DeviceControl1 = 0x11;
const STX_StartOfText = 0x02;
const ETB_EndOfBlock = 0x17;
const ETX_EndOfText = 0x03;
const EOT_EndOfTransmission = 0x04;
const C_ControlMessage = 0x43;
const P_PixelMode = 0x50;
const S_ScrollMode = 0x53;
const T_TextMode = 0x54;
const RS_RecordSeparator = 0x1E;
const Empty = "";
class message_processor {
    constructor(c, mqtt, lights) {
        this.cfg_ = c;
        this.mqtt_ = mqtt;
        this.lights_ = lights;
    }
    process(bytes, length) {
        return __awaiter(this, void 0, void 0, function* () {
            if (length == 0)
                return;
            const controlCode = bytes[0];
            if (controlCode !== DeviceControl1) {
                ArduinoGlobals_1.Serial.println("Not a device control command.");
                return;
            }
            const controlMode = bytes[1];
            ArduinoGlobals_1.Serial.println("Device Control 1 Message received. Mode is:");
            ArduinoGlobals_1.Serial.println(controlMode);
            switch (controlMode) {
                case P_PixelMode:
                    this.processSetPixelsMessage(bytes, length);
                    return;
                case C_ControlMessage:
                    this.processControlMessage(bytes, length);
                    return;
                case T_TextMode:
                    yield this.processSetTextMessage(bytes, length);
                    return;
            }
        });
    }
    processSetPixelsMessage(bytes, length) {
        ArduinoGlobals_1.Serial.println(ArduinoGlobals_1.F("processSetPixelsMessage"));
        let inPixelBlock = false;
        let r = 0;
        let g = 0;
        let b = 0;
        for (let i = 0; i < length; i++) {
            let current = bytes[i];
            if (inPixelBlock) {
                const x = current;
                const y = bytes[++i];
                this.lights_.update_pixel_by_coord(x, y, r, g, b, false);
                const next = bytes[i + 1];
                if (next !== RS_RecordSeparator) {
                    inPixelBlock = false;
                }
                else {
                    i++;
                }
                continue;
            }
            if (current == EOT_EndOfTransmission) {
                break;
            }
            if (current == ETB_EndOfBlock) {
                inPixelBlock = false;
                continue;
            }
            if (current === STX_StartOfText) {
                r = bytes[++i];
                g = bytes[++i];
                b = bytes[++i];
                inPixelBlock = true;
                continue;
            }
        }
        this.lights_.flush();
    }
    processControlMessage(bytes, length) {
        ArduinoGlobals_1.Serial.println(ArduinoGlobals_1.F("processControlMessage"));
        const controlMessageType = bytes[3];
        if (controlMessageType == 0) {
            this.lights_.clear();
        }
    }
    processSetTextMessage(bytes, length) {
        return __awaiter(this, void 0, void 0, function* () {
            const messageModeByte = bytes[2];
            const scrollSpeedMs = bytes[3];
            const r = bytes[4];
            const g = bytes[5];
            const b = bytes[6];
            const shouldScroll = messageModeByte == 1;
            this.printTextMessage(bytes, length);
            if (shouldScroll) {
                ArduinoGlobals_1.Serial.println(ArduinoGlobals_1.F("Scrolling enabled."));
                const maxWidthOffLeft = sprite_sheet_1.sprite_sheet.getTotalWidthOfText(bytes, length) * -1;
                let scrollPosition = this.cfg_.display.width;
                while (scrollPosition > maxWidthOffLeft) {
                    this.lights_.clearWithoutFlush();
                    this.drawEntireString(bytes, length, scrollPosition, r, g, b);
                    scrollPosition--;
                    yield ArduinoGlobals_1.delay(scrollSpeedMs);
                }
            }
            else {
                ArduinoGlobals_1.Serial.println(ArduinoGlobals_1.F("Scrolling disabled."));
                this.drawEntireString(bytes, length, 0, r, g, b);
            }
        });
    }
    drawEntireString(bytes, length, shiftXpositionBy, r, g, b) {
        const textStart = bytes.indexOf(STX_StartOfText) + 1;
        const footerLength = 2;
        const spaceWidth = 1;
        let xPosition = shiftXpositionBy;
        for (let i = textStart; i < length - footerLength; i++) {
            const asciiCode = bytes[i];
            const spriteAndWidth = sprite_sheet_1.sprite_sheet.spriteDataFor(asciiCode);
            this.drawSpriteAtPosition(spriteAndWidth.spriteData, spriteAndWidth.width, xPosition, r, g, b);
            xPosition += spriteAndWidth.width + spaceWidth;
        }
        this.lights_.flush();
    }
    drawSpriteAtPosition(sprite, width, xOffset, r, g, b) {
        let bytePosition = 0;
        for (let y = 0; y < 8; y++) {
            for (let x = 0; x < width; x++) {
                const value = sprite[bytePosition++];
                const alignedX = x + xOffset;
                if (value === 1) {
                    this.lights_.update_pixel_by_coord(alignedX, y, r, g, b, false);
                }
            }
        }
    }
    printTextMessage(bytes, length) {
        const textStart = search_utils_1.search_utils.indexOf(bytes, length, STX_StartOfText) + 1;
        const textEnd = search_utils_1.search_utils.indexOf(bytes, length, ETX_EndOfText);
        ArduinoGlobals_1.Serial.println("processSetTextMessage is:");
        for (let i = textStart; i < textEnd; i++) {
            let character = bytes[i];
            ArduinoGlobals_1.Serial.print(character);
        }
        ArduinoGlobals_1.Serial.println("");
    }
}
exports.message_processor = message_processor;
//# sourceMappingURL=message_processor.js.map